import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import animations from 'src/styles/animations';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.spin), {}, {
  modalContentLoader: {
    textAlign: 'center',
    padding: '88px 0',
    '& .MuiTypography-root': {
      marginTop: '10px'
    }
  },
  spinner: {
    '& .MuiSvgIcon-root': {
      display: 'inline-block',
      animation: '$spin 1.3s infinite linear',
      width: '64px',
      height: '64px',
      '& path': {
        fill: palette.primary.main
      }
    }
  }
}));
export default useStyles;